module.exports = __webpack_public_path__ + "img/image.8d3422a1.png";